interface AudioCapabilities {
  mp3Supported: boolean;
  aacSupported: boolean;
  mediaSourceSupported: boolean;
}

export function getAudioCapabilities(): AudioCapabilities {
  let mp3Supported = false;
  let aacSupported = false;

  try {
    mp3Supported = MediaSource.isTypeSupported('audio/mpeg');
    aacSupported = MediaSource.isTypeSupported('audio/aac');
  } catch (error) {
    // MediaSource API not available or error checking
    console.error('Can not use MediaSource api: ', error);
  }

  return {
    mp3Supported,
    aacSupported,
    mediaSourceSupported: mp3Supported && aacSupported,
  };
}
